import { createTheme } from "@mui/material/styles";

const colors = {
  primary: "#3080de",
  primaryLight: "rgba(48, 128, 222, 0.32)",
};

export let theme = createTheme({
  spacing: 4,
});

const spacingStyles = (
  theme,
  spacingTypesLength = 0,
  spacingKeyLabel = "spacing-xs"
) => {
  const hashMap = {};
  new Array(spacingTypesLength)
    .fill(0)
    .map((_, index) => {
      return {
        spacing: index + 1,
        themeSpacingValue: theme.spacing(index + 1),
      };
    })
    .map(({ spacing, themeSpacingValue }) => {
      themeSpacingValue = themeSpacingValue.replace(/[^0-9]/g, "");
      hashMap[`${spacingKeyLabel}-${spacing}`] = {
        margin: `-${themeSpacingValue}px`,
        width: `calc(100% + ${themeSpacingValue * 2}px)`,
        "> .MuiGrid-item": {
          padding: themeSpacingValue + "px",
        },
      };
      return true;
    });
  return hashMap;
};

theme = createTheme({
  typography: {
    fontFamily: ["Open sans"].join(","),
    root: {
      color: "#2a292a",
    },
    subtitle1: {
      fontWeight: "600",
      fontSize: "1rem",
    },

    h1: {
      fontSize: "96px",
      fontWeight: "normal",
      fontStyle: "normal",
      fontStretch: "normal",
      lineHeight: "normal",
    },
    h2: {
      fontSize: "60px",
    },
    h3: {
      fontSize: "48px",
      fontWeight: "600",
    },
    h4: {
      fontSize: "34px",
      color: "#2a292a",
      fontWeight: "normal",
    },
    h5: {
      fontSize: "24px",
      fontWeight: "normal",
    },
    h6: {
      fontSize: "22px",
      fontWeight: "600",
    },
    body1: {
      fontSize: "14px",
      lineHeight: "1.25",
      fontWeight: "normal",
      color: "#2a292a",
      //height: "20px",
    },
    paragraph: {
      fontWeight: "400",
      fontSize: "1rem",
    },
    caption: {
      color: "#0000008a",
      fontSize: "12px",
      letterSpacing: "0.4px",
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "normal",
    },
  },
  palette: {
    primary: {
      textColor: "white",
      // let these comments stay, they deliver useful information and are not dead-code
      // light: will be calculated from palette.primary.main,
      main: colors.primary,
      mainLight: colors.primaryLight,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: colors.primary,
      main: colors.primary,
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#FFFFFF",
    },
    // error: will use the default color
  },
  components: {
    MuiGrid: {
      styleOverrides: {
        ...spacingStyles(theme, 10),
      },
    },
    MuiTextArea: {
      height: "66.5px",
      padding: "0",
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          opacity: "1",
        },
      },
    },
    MuiDateTimePickerToolbar: {
      styleOverrides: {
        penIcon: {
          display: "none",
        },
      },
    },
    MuiPickersDatePickerToolbar: {
      styleOverrides: {
        penIcon: {
          display: "none",
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        dateTitleContainer: {
          display: "flex",
          justifyContent: "space-between",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingBottom: "0 !important",
        },
        padding: {
          minWidth: "248px",
          padding: "0 !important",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          // cursor: "pointer",
          "&:hover": {
            backgroundColor: "#eaf2fc",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
        outlined: {
          zIndex: 1,
          transform: "translate(14px, 20px) scale(1)",
          pointerEvents: "none",
          top: "-9px",
          // fontSize: "14px",
          color: "#9990a1",
          fontSize: "14px",
        },
        shrink: {
          transform: "translate(14px, 2px) scale(0.75) !important",
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        action: {
          [theme.breakpoints.down("md")]: {
            //display: "none",
            padding: "0px !important",
          },
        },
        root: {
          color: "#fff !important",
          [theme.breakpoints.down("md")]: {
            position: "relative",
            padding: "13px 17px",
            color: "#fff !important",
          },
        },
        // close:{
        //   [theme.breakpoints.down("sm")]: {
        //     padding:"0px !important",
        //   },
        // },
        message: {
          width: "91%",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          //minWidth: '30rem',
          //borderRadius: "0.5rem",
          borderRadius: "4px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: "2rem",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeLarge: {
          width: "17.5rem",
          color: "#ffffff",
          fontSize: "0.875rem",
          fontWeight: "800",
          letterSpacing: "0.4px",
        },
        root: {
          fontSize: "0.875rem",
          "&.Mui-disabled": {
            opacity: "0.5",
            backgroundColor: "#d7dee5 !important",
            border: "none 0px !important",
          },
        },
        contained: {
          color: "#ffffff",
          fontWeight: "600",
          boxShadow: "unset !important",
        },
        containedPrimary: {
          color: "#ffffff",
          fontWeight: "600",
          "&:hover": {
            boxShadow:
              "0 1px 2px 0 rgba(48, 128, 222, 0.32), 0 2px 8px 1px rgba(48, 128, 222, 0.32) !important ",
          },
        },
        outlinedPrimary: {
          color: colors.primary,
          borderWidth: "2px",
        },

        /*disabled:{
      backgroundColor:"#d7dee5 !important",
      border:"none 0px !important",
    }*/
      },
    },
    a: {
      styleOverrides: {
        color: "#3a99d9",

        text: {
          fontWeight: "600",
          fontSize: "1rem",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          [theme.breakpoints.down("md")]: {
            //height: '100%',
            maxHeight: "100% !important",
            margin: "0",
            borderRadius: "0",
            //padding: "1rem",
          },
          [theme.breakpoints.up("sm")]: {
            height: "auto",
          },
        },
        paperWidthSm: {
          maxWidth: "450px",
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: "center",
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            //   fontWeight: "600",
            //   color: "#000 !important",
          },
          "&.Mui-error": {
            color: "#f44336",
            //"fontSize": "0.875rem"
          },
        },
        /* error: {
      color: "#d0021b",
      fontSize: "0.875rem",
    },*/
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        lineHorizontal: {
          borderTopWidth: "2px",
          display: "flex",
          height: "2px !important",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          overflow: "auto",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          // paddingBottom: '0',
          //height: '15px',
          overflow: "initial",
          fontSize: "14px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          "&:first-of-type": {
            paddingTop: "0 !important",
          },
        },
      },
    },
    MuiExpansionPanel: {
      styleOverrides: {
        root: {
          "&:last-child": {
            borderTop: "1px solid rgba(0,0,0,0.12)",
            borderRadius: "0px 0px 5px 5px",
          },
          "&:first-of-type": {
            borderTop: "1px solid rgba(0,0,0,0.12)",
            borderRadius: "5px 5px 0px 0px",
          },
          "&:before": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ffffff",
            // "& p": {
            //   opacity: "0.3",
            // },
          },
          [theme.breakpoints.down("md")]: {
            //paddingRight:"8px",
          },
          "&.Mui-expanded": {
            marginTop: "0.5rem !important",
            marginBottom: "0.5rem !important",
            borderRadius: "5px !important",
            "&:first-of-type": {
              marginTop: "0px !important",
            },
          },
        },
      },
    },
    MuiExpansionPanelDetails: {
      styleOverrides: {
        root: {
          padding: "0px",
          "& > :first-child": {
            // paddingLeft: '4rem',
            // paddingRight: '1.5rem'
          },
        },
      },
    },
    MuiExpansionPanelActions: {
      styleOverrides: {
        root: {
          maxHeight: "3.5rem",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "red",
            "& text": {
              fill: "#FFFFFF",
              fontWeight: "600",
              fontSize: "14px",
            },
          },
        },
        text: {
          fill: "white",
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            fontWeight: "600 !important",
          },
        },
        label: {
          "&.MuiStepLabel-alternativeLabel": {
            [theme.breakpoints.down("md")]: {
              marginTop: "6px",
              fontSize: "12px",
            },
          },
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          width: "800px",
          [theme.breakpoints.down("md")]: {
            position: "relative",
            left: "0px",
            right: "0px",
            top: "0px",
            margin: "0px",
          },
        },
        anchorOriginTopCenter: {
          [theme.breakpoints.down("md")]: {
            top: "0px",
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          width: "24px",
          height: "24px",
        },
        track: {
          height: "6px",
          borderRadius: "3px",
        },
        trackBefore: {
          backgroundImage: "linear-gradient(to right, #95ee4f, #6fb934)",
        },
        trackAfter: {
          backgroundColor: "rgba(0, 0, 0, 0.38)",
        },
        activated: {
          [theme.breakpoints.down("md")]: {
            boxShadow: "unset !important",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          lineHeight: "1.5em",
          fontSize: "12px",
          color: "#9990a1",
        },
        contained: {
          margin: "0",
          paddingLeft: "12px",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        regular: {
          minHeight: "48px !important",
        },
        gutters: {
          [theme.breakpoints.down("md")]: {
            paddingRight: "8px",
            paddingLeft: "8px",
          },
        },
      },
    },
    MuiStepButton: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down("md")]: {
            marginRight: "0",
            paddingRight: "0",
          },
        },
      },
    },
    MuiExpansionPanelSummary: {
      styleOverrides: {
        root: {
          minHeight: "56px",
          "&.Mui-expanded": {
            //borderBottom: "1px solid rgba(0,0,0,.125)",
            /* min-height: 64px; */
            minHeight: "56px",
          },
          "&.Mui-disabled": {
            opacity: "1 !important",
          },
        },
        expandIcon: {
          padding: "0 !important",
          [theme.breakpoints.up("sm")]: {
            right: "13px !important",
          },
          [theme.breakpoints.down("md")]: {
            right: "8px !important",
          },
        },
        content: {
          margin: "6px 0",
          "&.Mui-expanded": {
            margin: "0 0 !important",
          },
          marginRight: "2px",
          [theme.breakpoints.down("md")]: {
            marginRight: "0px",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: "unset !important",
          },
        },
        icon: {
          marginRight: "8px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          minHeight: "40px",
        },
        input: {
          padding: "10.5px 14px",
          fontSize: "14px",
          //fontWeight: 600,
          color: "#2a292a",
          // overflowY:"hidden",
        },
        multiline: {
          padding: "0px",
          fontSize: "14px",
          // fontWeight: 600
        },
        notchedOutline: {
          borderRadius: "4px",
          border: "solid 1px ",
          color: "#cec3d8",
          borderColor: "#cec3d8",
        },
        inputMultiline: {
          paddingRight: "10px",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          margin: "0 8px 0 8px !important",
          padding: "0 !important",
          "&.Mui-checked": {
            color: `${colors.primary} !important`,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: `${colors.primary} !important`,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        label: {
          "&:hover": {
            borderRadius: "4px",
            //boxShadow: '0 1px 2px 0 rgba(186, 171, 199, 0.36), 0 2px 8px 1px rgba(186, 171, 199, 0.24)',
            //backgroundColor: '#fcfdfe',
            opacity: "0.8",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: "#fafafa !important",
          padding: "9px !important",
        },
        root: {
          "&.Mui-checked": {
            color: "#7ec93c !important",
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          color: "#0000008a",
          fontSize: "12px",
        },
        caption: {
          fontSize: "12px",
          letterSpacing: "0.4px",
        },
        select: {
          fontSize: "12px",
          paddingRight: "40px !important",
        },
        selectIcon: {
          top: "calc(50% - 14px)",
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        child: {
          //backgroundColor: 'rgba(66, 64, 67, 0.08)',
          opacity: "0.08",
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
    MuiAccordionDetails: {
      styleOverrides:{
        root: {
          padding: 0,
        },
      },
    },
  },
});

export const styles = (theme) => ({
  displayNone: {
    display: "none",
  },
  primaryLink: {
    color: theme.palette.primary.main,
    textTransform: "capitalize",
  },
  errorLink: {
    color: theme.palette.error.main,
    textTransform: "capitalize",
  },
  profileIcon: {
    color: "#baabc7",
  },
  mvTitle: {
    fontSize: "20px",
    letterSpacing: "0.25px",
    //fontWeight:'bold'
  },
  appRoot: {
    width: "100%",
    minHeight: "768px",
    backgroundColor: "#f5f7fb",
    display: "flex",
    flexDirection: "column",
  },
  headerWrap: {
    height: "56px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    //paddingLeft: "30px",
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)",
    // zIndex:'11111'
  },
  menuWrap: {
    marginTop: "0",
  },
  logOutIcon: {
    verticalAlign: "text-bottom",
  },
  pageWrapper: {
    width: "100%",
    height: "768px",
    backgroundColor: "#f5f7fb",
  },
  formBox: {
    width: "288px",
    height: "40px",
    borderRadius: "4px",
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  brandLogo: {
    width: "84px",
    height: "32px",
    cursor: "pointer",
  },
  branLogoSeparator: {
    width: "1px",
    backgroundColor: "#D4CBDC",
    transform: "rotate(28deg)",
    marginLeft: "18px",
    marginRight: "12px",
    height: "32px",
  },
  webLogo: {
    "& div": {
      //height: "32px"
    },
    paddingLeft: "0px",
  },
  iconButton: {
    marginRight: "8px",
  },
  accountIcon: {
    color: "#9990a1",
  },
  color4a4a4a: {
    color: "#4a4a4a",
  },
  color4a90e2: {
    color: "#4a90e2",
  },
  itemWidth: {
    width: "100%",
  },

  /**
   *  common style classes
   */
  bold: {
    fontWeight: "600",
  },
  fontWeight400: {
    fontWeight: "400 !important",
  },
  fontWeight600: {
    fontWeight: "600",
  },
  bold2: {
    fontWeight: "800",
  },
  bold3: {
    fontWeight: "bold",
  },
  gridContainer: {
    margin: "unset !important",
    width: "100%",
    //overflow:'auto'
  },
  widthMargin: {
    margin: "unset !important",
  },
  widthFit: {
    width: "100%",
  },
  heightFit: {
    height: "100% !important",
  },
  blackColor: {
    color: "#2a292a",
  },
  whiteColor: {
    color: "#FFFFFF",
  },
  textUpperCase: {
    textTransform: "uppercase",
  },
  txtAlignCenter: {
    textAlign: "center",
  },
  textAlignLeft: {
    textAlign: "left",
  },
  textAlignRight: {
    textAlign: "right",
  },
  textCut: {
    textDecoration: "line-through",
  },
  tSuccess: {
    color: "#70BB31 !important",
  },

  /** padding classes */
  padding16: {
    padding: "16px",
  },
  padding32: {
    padding: "32px",
  },
  padding48: {
    padding: "32px",
  },
  padding4: {
    padding: "4px !important",
  },
  padding0: {
    padding: "0 !important",
  },
  padding8: {
    padding: "8px !important",
  },
  paddingBottom0: {
    paddingBottom: "0 !important",
  },
  paddingBottom8: {
    paddingBottom: "8px !important",
  },
  paddingBottom12: {
    paddingBottom: "12px !important",
  },
  paddingBottom16: {
    paddingBottom: "1rem !important",
  },

  paddingTop0: {
    paddingTop: "0 !important",
  },
  paddingTop8: {
    paddingTop: "8px !important",
  },
  paddingTop16: {
    paddingTop: "16px !important",
  },
  paddingTop24: {
    paddingTop: "24px !important",
  },
  paddingTop32: {
    paddingTop: "32px !important",
  },
  paddingLeft0: {
    paddingLeft: "0px !important",
  },
  paddingLeft4: {
    paddingLeft: "4px",
  },
  paddingLeft8: {
    paddingLeft: "8px",
  },
  paddingLeft16: {
    paddingLeft: "16px",
  },
  paddingRight8: {
    paddingRight: "8px",
  },
  paddingRight16: {
    paddingRight: "1rem !important",
  },
  paddingRight0: {
    paddingRight: "0px !important",
  },
  paddingTopBottom12: {
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  paddingTopBottom16: {
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  paddingLeftRight16: {
    paddingLeft: "16px",
    paddingRight: "16px",
  },

  /** margin classes */
  margin0: {
    margin: "0 !important",
  },
  marginTop4: {
    marginTop: "4px !important",
  },
  marginTop8: {
    marginTop: "0.5rem !important",
  },
  marginRight12: {
    marginRight: "12px",
  },
  marginTop16: {
    marginTop: "1rem !important",
  },
  marginTop24: {
    marginTop: "1.5rem !important",
  },
  marginBottom16: {
    marginBottom: "16px !important",
  },
  marginBottom8: {
    marginBottom: "8px !important",
  },
  marginBottom24: {
    marginBottom: "1.5rem !important",
  },
  marginTop32: {
    marginTop: "2rem !important",
  },
  marginLeft8: {
    marginLeft: "8px !important",
  },
  marginLeft16: {
    marginLeft: "16px !important",
  },
  marginRight8: {
    marginRight: "8px !important",
  },
  marginRight16: {
    marginRight: "16px !important",
  },
  marginLeft4: {
    marginLeft: "4px !important",
  },
  marginButton8: {
    marginBottom: "8px !important",
  },
  marginBottom12: {
    marginBottom: "12px !important",
  },
  margin8: {
    margin: "8px !important",
  },

  /** Typography */

  t16Bold: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#000000",
    lineHeight: "1.43",
  },
  t16: {
    fontSize: "16px",
    color: "#000000",
    lineHeight: "1.43",
  },
  t14: {
    fontSize: "14px",
    lineHeight: "1.43",
    color: "#000000",
  },
  t14Bold: {
    fontSize: "14px",
    color: "#000000",
    fontWeight: "600",
    lineHeight: "1.43",
  },
  t12: {
    fontSize: "12px",
    lineHeight: "1.43",
    color: "#000000",
  },
  t12Bold: {
    fontSize: "12px",
    color: "#000000",
    fontWeight: "600",
    lineHeight: "1.43",
  },
  t22Bold: {
    fontSize: "22px",
    color: "#000000",
    fontWeight: "600",
    lineHeight: "30px",
  },
  tNotificationCount: {
    color: "white",
    background: "#4a90e2",
    display: "inline-block",
    padding: "3px 7px",
    borderRadius: "50%",
    fontSize: "12px",
  },
  tCaption: {
    color: "#9990a1",
  },
  tCaption2: {
    color: "rgba(42, 41, 42, 0.87)",
  },
  tCaption3: {
    color: "#2a292a",
  },
  tWhite: {
    color: "white",
  },
  tLink: {
    color: "#3b79c0",
    cursor: "pointer",
  },
  t12CapsBold: {
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  t22: {
    fontSize: "22px",
    color: "#000000",
    lineHeight: "1.43",
  },
  tCaps: {
    textTransform: "capitalize",
  },
  tEC7474: {
    color: "#ec7474",
  },
  tAlignCenter: {
    textAlign: "center",
  },
  tTag1: {
    color: "white",
    backgroundColor: "#9990A1",
    padding: "0px 4px",
  },
  /** Alignment */
  floatLeft: {
    float: "left",
  },
  floatRight: { float: "right" },

  /** Display */
  displayInlineBlock: {
    display: "inline-block",
  },

  heighLightBg: {
    backgroundColor: "#f5f7fb",
  },

  subHeaderItem: {
    marginLeft: "16px",
  },
  textOverflowEllipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  LowRisk: { backgroundColor: "#6FB934" },
  MediumRisk: { backgroundColor: "#FCC945" },
  HighRisk: { backgroundColor: "#F28500" },
  ExtremeRisk: { backgroundColor: "#E12B1D" },
  // Separator
  separatorTop: {
    borderTop: "solid 1px #e0e0e0",
  },
  separatorBottom: {
    borderBottom: "solid 1px #e0e0e0",
  },

  takeRestSpace: {
    flexGrow: "1",
  },

  userAvatar: {
    borderRadius: "50%",
  },
  anchorCssOverride: {
    textDecoration: "none",
    color: "inherit",
    "&:visited": {
      color: "inherit",
    },
  },

  // layout
  layoutContainer: {
    display: "flex",
    flexFlow: "column",
    height: "100%",
  },
  layoutHeader: {
    flex: "0 1 auto",
  },
  layoutBody: {
    flex: "1 1 auto",
  },
  layoutFooter: {
    flex: "0 1 auto",
  },

  // position
  positionRelative: {
    position: "relative",
  },
  positionAbsolute: {
    position: "absolute",
  },

  // right and top 
  right16:{
    right:"16px"
  },
  top16:{
    top:"16px"
  },

  //border
  borderBottom: {
    borderBottom: "solid 1px #d7dee5",
  },

  // cursor
  cursorPointer: {
    cursor: "pointer",
  },
  filterCard:{
    top: "0px",
    right: "0px",
    height: "100%",
    position: "fixed",
    opacity: 1,
    zIndex: "1210",
    padding: "20px",
    maxWidth: "400px",
  },
  contentCenter:{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  viewPortHeight:{
    height: "100vh",
  },
  height100:{
    height:"100%"
  },
  _6FB934:{
  backgroundColor: "#6FB934"
  },
  _F1F1F1:{
  backgroundColor: "#F1F1F1",
  },
  _F28500:{
    backgroundColor: "#F28500",   
  },
  _73757A:{
    backgroundColor: "#73757A",
  },
  _558FE5:{
    backgroundColor: "#558FE5",
  },                     
  _6fb934: {  
    backgroundColor: "#6fb934",
  },
  _f3985c: {
    backgroundColor: "#f3985c",
  },
  _6aaa36: {
    backgroundColor: "#6aaa36",
  },
  _ed9292: {
    backgroundColor: "#ed9292",
  },
  _6d354f: {
    backgroundColor: "#6d354f",
  },
  _94c3fb: {
    backgroundColor: "#94c3fb",
  },
  _e08138: {
    backgroundColor: "#E08138",
  },
  _dc4b40: {
    backgroundColor: "#dc4b40",
  },
  statusText: {
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.5",
    letterSpacing: "1.5px",
    textAlign: "center",
    color: "#ffffff",
  },
  circleIcon: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "#cf3e2d",
    display: "inline-block",
    marginLeft: "10px",
  },
});
